import { FormDonorUpdate } from '3-components/OptimizelyForm';
import { useDonorBlockProps } from '../DonorDetailProvider';
import { type FC } from 'react';
import HTMLReactParser from 'html-react-parser';
import PrivacyLink from '../components/PrivacyLink';
import useFormIdentity from '3-components/OptimizelyForm/hooks/useFormIdentity';

export const DonorForm: FC = () => {
    const { baseURL, detailForm, introText } = useDonorBlockProps();

    const identityToken = useFormIdentity();

    if (!baseURL) {
        console.error('Missing baseURL configuration');
        return null;
    }

    if (!detailForm) {
        console.error('Missing form configuration');
        return null;
    }

    const { formID, locale } = detailForm;

    return (
        <div className="donor-form__outer">
            {introText && (
                <div className="donor-block-intro">{HTMLReactParser(introText)}</div>
            )}
            <div className="donor-form__wrapper">
                <FormDonorUpdate
                    baseUrl={`${baseURL}/`}
                    formKey={formID}
                    language={locale}
                    identityInfo={identityToken}
                />
            </div>
            <PrivacyLink />
        </div>
    );
};
